import * as Yup from 'yup'

import flow from 'lodash/flow'

import date from '@galo-monitor/forms/validators/date.validator'
import float from '@galo-monitor/forms/validators/float.validator'
import required from '@galo-monitor/forms/validators/required.validator'

const pesticideApplicationSchema = ({ t, data }) => Yup.object().shape({
  plots: Yup.array().of(Yup.object().shape({
    id: required({ t, isNotText: true })(Yup.boolean())
  })),
  date_initial: flow(
    date({ t }),
    required({ t })
  )(Yup.string()),
  date_finish: flow(
    date({ t }),
    required({ t })
  )(Yup.string()),
  area_total: flow(
    float({ t }),
    required({ t })
  )(Yup.string()),
  agricultural_inputs: Yup.array().of(Yup.object().shape({
    agricultural_input_id: required({ t })(Yup.string()),
    unit: required({ t })(Yup.string()),
    recommendation_per_hectare: flow(
      required({ t }),
      float({ t })
    )(Yup.string()),
    quant_total: flow(
      required({ t }),
      float({ t })
    )(Yup.string())
  })),
  dilute_in_syrup: required({ t })(Yup.string()),
  volume_syrup:
    data.dilute_in_syrup
      ? required({ t })(Yup.string())
      : Yup.string(),
  total_syrup:
    data.dilute_in_syrup
      ? required({ t })(Yup.string())
      : Yup.string(),
  stock_id: required({ t })(Yup.string()),
  machines: Yup.array().of(Yup.object().shape({
    machine_id: required({ t })(Yup.string())
  })),
  user_responsible_id: required({ t })(Yup.string())
})

export default pesticideApplicationSchema
